function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import { node, string, object, bool, oneOfType, number } from 'prop-types';
import cx from 'classnames';
import { Text } from './../Text/Text';
import { Color, Display } from './../../enhancers';
import css from './Badge.sass';

var BaseBadge = function BaseBadge(_ref) {
  var children = _ref.children,
      content = _ref.content,
      textProps = _ref.textProps,
      className = _ref.className,
      round = _ref.round;
  return content ? React.createElement("div", {
    className: cx(css.root, className, round && css.round)
  }, React.createElement(Text, _extends({
    className: css.text,
    size: round ? '10' : '12',
    weight: round ? 'bolder' : 'normal',
    lineHeight: "s",
    content: typeof content === 'number' ? "".concat(content) : content
  }, textProps), children)) : null;
};

BaseBadge.propTypes = {
  children: node,
  content:
  /*#__PURE__*/
  oneOfType([string, number]),
  textProps: object,
  className: string,

  /** Make badge round */
  round: bool
};
BaseBadge.displayName = 'Badge';
/* Adding enhancers */

var ColoredBadge = function ColoredBadge(props) {
  return React.createElement(Color, _extends({
    InputComponent: BaseBadge
  }, props));
};

var Badge = function Badge(props) {
  return React.createElement(Display, _extends({
    InputComponent: ColoredBadge
  }, props));
};

Badge.propTypes = {
  display: string
};
Badge.defaultProps = {
  display: 'inline-block'
};
export { Badge };